module.exports = __webpack_public_path__ + "img/win.f36c89c3.png";